import type { FC, ReactNode } from "react";

interface GraphContainerProps {
  children: ReactNode;
  height?: string | number;
  className?: string;
}

export const GraphContainer: FC<GraphContainerProps> = ({
  children,
  height = 560,
  className = "",
}) => {
  const heightStyle = typeof height === "number" ? `${height}px` : height;

  return (
    <div
      className={`relative w-full rounded-none border border-slate-300 bg-slate-50/80 shadow-inner shadow-gray-200 dark:border-2 dark:border-slate-700 dark:bg-slate-900/70 dark:shadow-black/30 ${className}`}
      style={{ height: heightStyle }}
    >
      {children}
    </div>
  );
};
